// extracted by mini-css-extract-plugin
export default {"tabList":"Tabs_tabList__0K51d","tabLabel":"Tabs_tabLabel__IFpf8","tabLabelActive":"Tabs_tabLabelActive__lziUD"};